<ng-container [formGroup]="checkboxGroup">
  @if (label) {
  <label class="col-form-label">{{ label }}</label>
  }
  <div class="mb-2">
    @for (checkbox of checkboxList; track checkbox) {
    <nh-checkbox
      [inline]="inline"
      [control]="checkboxGroup.get(checkbox.control)"
      [checkedValue]="checkbox.reference"
      [label]="checkbox.reference.value"
      [disabled]="disabled"
      [readonly]="checkbox.readonly"
      [name]="checkbox.control"
      [index]="uniqueString"
      [ariaRequired]="ariaRequired"
      [globalLangTranslate]="globalLangTranslate"
      [fromCheckboxList]="fromCheckboxList"
    >
    </nh-checkbox>
    }
  </div>
</ng-container>